import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import { useState } from 'react';

import { FilterSpotlight } from './FilterSpotlight';

import { MoreActionsSpotlight } from './MoreActionsSpotlight';

import { type JSX } from 'react/jsx-runtime';

export const HighImpactSpotlightTour = ({
	onDismiss,
}: {
	onDismiss: (isTourCompleted?: boolean) => void;
}): JSX.Element | null => {
	const { onStepChanged } = usePostOfficeUserInteractions();
	const [currentStep, setCurrentStep] = useState<number>(1);

	const next = () => {
		setCurrentStep(Math.min(currentStep + 1, 2));
		void onStepChanged({
			interactionIdentifier: 'exploreActions',
			direction: 'next',
			fromStep: 1,
			toStep: 2,
		});
	};

	const endTour = (isTourCompleted = false) => {
		setCurrentStep(0);
		onDismiss(isTourCompleted);
	};

	if (currentStep === 0) {
		return null;
	}

	return (
		<>
			<FilterSpotlight onNext={next} onDismiss={endTour} isVisible={currentStep === 1} />
			<MoreActionsSpotlight onFinish={endTour} isVisible={currentStep === 2} />
		</>
	);
};
